module.exports = __webpack_public_path__ + "img/live session added illustration.e6c70efb.svg";